import React from "react";
import logo from "../images/logo.png";

const PrivacyPolicyPage = () => {
  const styles = {
    container: {
      backgroundColor: "#f8f9fa",
      minHeight: "100vh",
      fontFamily: "'Inter', sans-serif"
    },
    header: {
      backgroundColor: "#ffffff",
      padding: "1rem 2rem",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      display: "flex",
      alignItems: "center"
    },
    logo: {
      height: "40px",
      objectFit: "contain"
    },
    main: {
      maxWidth: "1000px",
      margin: "0 auto",
      padding: "2rem"
    },
    heroCard: {
      background: "linear-gradient(135deg, #2b5876 0%, #4e4376 100%)",
      borderRadius: "16px",
      padding: "3rem",
      color: "white",
      marginBottom: "2rem",
      boxShadow: "0 10px 20px rgba(0,0,0,0.1)"
    },
    badge: {
      background: "rgba(255,255,255,0.2)",
      padding: "4px 12px",
      borderRadius: "20px",
      fontSize: "0.8rem",
      display: "inline-block",
      marginBottom: "1.5rem"
    },
    heroTitle: {
      fontSize: "2rem",
      fontWeight: "bold",
      marginBottom: "1rem"
    },
    heroDesc: {
      fontSize: "1rem",
      opacity: 0.9,
      maxWidth: "600px",
      lineHeight: 1.5
    },
    sectionCard: {
      backgroundColor: "white",
      borderRadius: "12px",
      padding: "2rem",
      boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
      marginBottom: "1.5rem"
    },
    sectionTitle: {
      fontSize: "1.25rem",
      fontWeight: "bold",
      color: "#1F4E78",
      marginBottom: "1rem",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    sectionText: {
      color: "#4a5568",
      fontSize: "0.95rem",
      lineHeight: 1.6,
      marginBottom: "1rem"
    },
    ul: {
      marginLeft: "1.5rem",
      color: "#4a5568",
      fontSize: "0.95rem",
      lineHeight: 1.6
    }
  };

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <img src={logo} alt="BSS Logo" style={styles.logo} />
      </header>

      <main style={styles.main}>
        {/* Hero Section */}
        <div style={styles.heroCard}>
          <div style={styles.badge}>🛡️ PRIVACY POLICY</div>
          <h1 style={styles.heroTitle}>Privacy Policy for BSS AI</h1>
          <p style={styles.heroDesc}>
            Effective Date: August 19, 2026
          </p>
        </div>

        {/* Content Sections */}
        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>1. Introduction</h2>
          <p style={styles.sectionText}>
            Welcome to BSS AI. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application ("App"). BSS AI is an internal business tool designed for authorized employees and personnel to access real estate CRM data, monitor sales, and manage projects.
          </p>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>2. Information We Collect</h2>
          <p style={styles.sectionText}>
            We only collect the information necessary to provide the App's core functionality.
          </p>
          <ul style={styles.ul}>
            <li><strong>Phone Number:</strong> We require your phone number to authenticate your identity, log you into the App securely, and authorize your access to internal company dashboards.</li>
          </ul>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>3. How We Use Your Information</h2>
          <p style={styles.sectionText}>
            The information we collect is used strictly for internal business purposes and app functionality:
          </p>
          <ul style={styles.ul}>
            <li>To verify your identity and employment status.</li>
            <li>To create and manage your secure account within the App.</li>
            <li>To prevent fraudulent access and maintain the security of company data.</li>
          </ul>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>4. Data Sharing and Disclosure</h2>
          <p style={styles.sectionText}>
            We respect your privacy. We do not sell, rent, or trade your personal information to third parties. Your phone number and access logs are kept strictly within our internal systems for administrative and security purposes. We will only share data if required by law or to protect the rights and safety of our company.
          </p>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>5. Tracking and Advertising</h2>
          <p style={styles.sectionText}>
            BSS AI does not use your data for tracking purposes. We do not use third-party advertising networks, nor do we track your activity across other apps or websites.
          </p>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>6. Data Security</h2>
          <p style={styles.sectionText}>
            We implement industry-standard security measures to protect the data accessed and transmitted through the App. However, please remember that no method of transmission over the internet or electronic storage is 100% secure.
          </p>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>7. Changes to This Privacy Policy</h2>
          <p style={styles.sectionText}>
            We may update this Privacy Policy from time to time to reflect changes in our internal practices. We will notify users of any significant changes by updating the "Effective Date" at the top of this policy.
          </p>
        </div>

        <div style={styles.sectionCard}>
          <h2 style={styles.sectionTitle}>8. Contact Us</h2>
          <p style={styles.sectionText}>
            If you have any questions or concerns about this Privacy Policy or how your data is handled, please contact your internal IT or HR administrator.
          </p>
        </div>

      </main>
    </div>
  );
};

export default PrivacyPolicyPage;
